module.exports = __webpack_public_path__ + "static/media/refund.1d2a38d2.svg";